import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No lending backend exists in this
// environment: risk parameters, collateral requirements, and the initiator name were
// previously fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryLendingBorrowPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Lending", href: "/treasury/lending" }], label: "Borrow Intent" }}
      state={{
        title: "Creating a borrow intent is not available in this environment yet",
        description: "Creating a borrow intent requires risk parameter evaluation and approval routing through the lending/approval backend, which does not exist in this environment yet.",
      }}
    />
  );
}
